<template>
    <div class="popup popup--vue" v-bind:class="{'is-active': show}">
        <div class="popup__content">
            <div class="popup__header ">
                <div class="title-3">{{$t('components.CustomDimensionsPopup.title')}}</div>
                <button @click="closePopup" class="popup__close" aria-label="{{$t('common.close')}}"></button>
            </div>
            <div class="popup__body p-0">
                <div class="collection l-white">
                    <div class="row no-gutters position-relative">
                        <div class="col-md-6 align-self-center">
                            <div class="collection__inner">
                                <div class="collection__content">
                                    <div class="collection__perex">
                                        {{$t('components.CustomDimensionsPopup.text')}}
                                    </div>

                                    <!-- Form -->
                                    <!-- DOTO-devel texty šířka+výška -->
                                    <div class="d-flex align-items-end mt-4">
                                        <label class="custom-formField--input mb-0 mr-2">
                                            <span>Šířka (cm)</span>
                                            <input type="number" v-model="width">
                                        </label>
                                        <label class="custom-formField--input mb-0 mr-2">
                                            <span>Výška (cm)</span>
                                            <input type="number" v-model="length">
                                            </label>
                                        <button class="btn btn--popup btn--black btn--small" @click="submit"> OK</button>
                                    </div>


                                    <br>
                                    <span v-if="errorMessage" style="">
                                        {{errorMessage}}
                                    </span>

                                    <div>
                                        {{$t('components.CustomDimensionsPopup.infoText')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                width: this.dimensions.width,
                length: this.dimensions.length,
                errorMessage: null
            };
        },
        props: ["show", "dimensions"],
        computed: {},
        watch: {
            dimensions: function(newVal) {
                this.width = newVal.width;
                this.length = newVal.length;
            },
            show: function(newVal) {
              if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
        methods: {
            submit() {
                if(!this.validateDimensions()) {
                    return;
                }
                const payload = {
                    values: {
                        width: this.width,
                        length: this.length
                    }
                };
                this.resetValues();
                this.closePopup();
                this.$emit("setCustomDimensions", payload);
            },
            closePopup() {
                this.$emit('customDimensionsClose');
            },
            resetValues() {
                this.width = null;
                this.length = null;
            },
            validateDimensions() {
                this.errorMessage = null;
                try {
                    this.validateValue('width', 'Šířka');
                    this.validateValue('length', 'Délka');
                    return true;
                } catch(errorText) {
                    this.errorMessage = errorText;
                    return false;
                }
            },
            validateValue(inputName, inputLabel) {
                const value = parseFloat(this[inputName]);
                if(value == '' || typeof value == 'undefined' || value == 0 || isNaN(value)) {
                    throw inputLabel + ' nemůže být prázdná či nulová.';
                }
            },
        }
    };
</script>
